module.exports = __webpack_public_path__ + "static/media/con_spa_sur.a6bdb894.png";